'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPets = function MdPets(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.9 24.8c2.2 2.2 4.9 4.5 4.4 7.9-0.5 1.8-1.7 3.5-3.9 3.9-1.3 0.3-5.1-0.7-9.2-0.7h-0.4c-4.1 0-7.9 1-9.2 0.7-2.2-0.4-3.4-2.1-3.9-3.9-0.4-3.3 2.2-5.8 4.4-7.9 1.5-1.8 2.7-3.2 4.1-4.9 0.8-0.9 1.8-1.8 2.9-2.2 0.2 0 0.4-0.1 0.6-0.1 0.4-0.1 0.8-0.1 1.3-0.1s0.9 0 1.3 0.1c0.2 0 0.4 0.1 0.6 0.1 1.1 0.4 2.1 1.3 2.9 2.2 1.4 1.7 2.6 3.1 4.1 4.9z m-0.5-8.9c0-2.3 1.8-4.3 4.1-4.3s4.1 2 4.1 4.3-1.8 4.1-4.1 4.1-4.1-1.9-4.1-4.1z m-7.5-6.8c0-2.2 1.8-4.1 4.1-4.1s4.1 1.9 4.1 4.1-1.8 4.3-4.1 4.3-4.1-2-4.1-4.3z m-10 0c0-2.2 1.8-4.1 4.1-4.1s4.1 1.9 4.1 4.1-1.8 4.3-4.1 4.3-4.1-2-4.1-4.3z m-7.5 6.8c0-2.3 1.8-4.3 4.1-4.3s4.1 2 4.1 4.3-1.8 4.1-4.1 4.1-4.1-1.9-4.1-4.1z' })
        )
    );
};

exports.default = MdPets;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/pets.js
// module id = 1766
// module chunks = 168707334958949